export const getAllowedSubsidiary = (
  subsidiaries: string[],
  allowedSubsidiaries: string[],
) => subsidiaries.some((id) => allowedSubsidiaries.includes(id));
